
































import { Vue, Component } from 'vue-property-decorator'
import { CarouselItem, CardItem } from '@/typescript/types'

@Component
export default class Home extends Vue {
  public carousels: CarouselItem[] = [
    { color: 'grey darken-4', title: 'Play Now', subtitle: 'Dungeons are now available, register and play now', button: 'Play', route: 'https://happy-turing-797997.netlify.app/' },
    // { color: 'blue darken-2', title: 'Dev Tracker', subtitle: 'Track the latest patch progress', button: 'View Tracker', route: '/development' },
    { color: 'blue-grey lighten-2', title: 'News', subtitle: '2022 update is now available', button: 'View News', route: '/news' },
    { color: 'blue-grey darken-2', title: 'Roadmap', subtitle: 'View the game\'s progress', button: 'View Progress', route: '/roadmap' },
    { color: 'cyan darken-4', title: 'FAQ', subtitle: 'Read the latest FAQ', button: 'View FAQ', route: '/faq' }
  ]

  public cards: CardItem[] = [
    { title: 'Classic Inspiration', text: 'Inspiration is derived from MUDs and online text-based RPGs like Vagabond\'s Quest.' },
    { title: 'Fair Grinds', text: 'Character building is about having choices on what to grind without demanding excessive time.' },
    { title: 'Convenient Play', text: 'Play as short as 2-minute sessions on any device solo or with others via parties or matchmaking.' },
    { title: 'No Pay-To-Win', text: 'There will never be advantageous items for money.' },
    { title: 'Multiplayer', text: 'Co-op, highly tactical PvP combat, and player-driven economy are fully supported.' },
    { title: 'Expansive Classes', text: 'Defend your party as a Knight, heal as a Priest, destroy as an Arcane Archer, debilitate as a Ranger, assassinate as a Rogue, or try many other classes!' }
  ]

  public get isMobile (): boolean {
    return this.$store.state.isMobile
  }

  public route (path: string) {
    if (/https/g.test(path)) window.open(path)
    else this.$router.push(path)
  }
}
